import { get } from 'svelte/store';
import { backend_url, access_token, storeLanguage, lang_fr } from './store';
import { storeUsers, storeUsersError, storeIsLogin, storeUserLogin, storeUserEmpty } from './user';
import { authentication } from './api';
import { addNotificationInfo, addNotificationError } from "./toaster";
import { userTypes } from '../scripts/constants';
import { setCookie } from './utils';
/**
 * getActiveMembers
 * /users/activemembers/ - GET
 */
export async function getActiveMembers() {
    const apiUrl = get(backend_url) + "v1/users/activemembers/";
    await authentication();
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache'
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeUsers.set(data);
        storeUsersError.set("");
        return true;
    })
        .catch((error) => {
        storeUsers.set([]);
        storeUsersError.set(initError(error));
        return false;
    });
}
/**
 * getUserByEmail
 * /users/byemail - POST
 */
export async function getUserByEmail($email, $password) {
    const apiUrl = get(backend_url) + "v1/users/byemail/";
    await authentication();
    const data = {
        email: $email,
        password: $password,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeUserLogin.set(data);
        storeIsLogin.set(true);
        const labelType = userTypes.filter((item) => item.id == data.user_type)[0];
        const cookieValue = $email + "#" + data.token;
        setCookie("cat-login", cookieValue, 1);
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationInfo("Bienvenue " + data.first_name + " " + data.last_name);
        }
        else {
            addNotificationInfo("Welcome " + data.first_name + " " + data.last_name);
        }
        return true;
    })
        .catch((error) => {
        storeUserLogin.set(storeUserEmpty);
        storeIsLogin.set(false);
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("Utilisateur inconnu ou informations de connection incorrectes");
        }
        else {
            addNotificationError("Unknown user or incorrect login information");
        }
        return false;
    });
}
/**
 * getUserByToken
 * /users/bytoken - POST
 */
export async function getUserByToken($email, $token) {
    const apiUrl = get(backend_url) + "v1/users/bytoken/";
    await authentication();
    const data = {
        email: $email,
        token: $token,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeUserLogin.set(data);
        storeIsLogin.set(true);
        const labelType = userTypes.filter((item) => item.id == data.user_type)[0];
        const cookieValue = $email + "#" + data.token;
        setCookie("cat-login", cookieValue, 1);
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationInfo("Bienvenue " + data.first_name + " " + data.last_name);
        }
        else {
            addNotificationInfo("Welcome " + data.first_name + " " + data.last_name);
        }
        return true;
    })
        .catch((error) => {
        storeUserLogin.set(storeUserEmpty);
        storeIsLogin.set(false);
        return false;
    });
}
/**
 * addUser
 * /users/ - POST
 */
export async function addUser($email, $password, $first_name, $last_name, $enterprise, $enterprise_other, $job) {
    if ($email == undefined || $email == "" || $password == undefined || $password == "" || $first_name == undefined || $first_name == "" || $last_name == undefined || $last_name == "") {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("Merci de renseigner tous les champs");
        }
        else {
            addNotificationError("Please fill in all fields");
        }
        return false;
    }
    const apiUrl = get(backend_url) + "v1/users/";
    await authentication();
    let formData = new FormData();
    formData.append("email", $email);
    formData.append("password", $password);
    formData.append("first_name", $first_name);
    formData.append("last_name", $last_name);
    formData.append("enterprise", $enterprise.toString());
    formData.append("enterprise_other", $enterprise_other.toString());
    formData.append("job", $job);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: formData,
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationInfo("Votre demande d'inscription est prise en compte,<br /> nous vous contacterons rapidement");
        }
        else {
            addNotificationInfo("Your registration request has been taken into account,<br /> we will contact you shortly");
        }
        return "200";
    })
        .catch((error) => {
        if (error == "Error: 409") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Cet utilisateur existe déjà.</br> Connectez vous ou réinitialisez votre mot de passe");
            }
            else {
                addNotificationError("This user already exists.</br> Login or reset your password");
            }
            return "409";
        }
        else {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Credentials invalides");
            }
            else {
                addNotificationError("Invalid credentials");
            }
            return "400";
        }
    });
}
/**
 * updateUser
 * /users/ - PUT
 */
export async function updateUser($id, $first_name, $last_name, $photo, $linkedin, $twitter, $enterprise, $job) {
    if ($first_name == undefined || $first_name == "" ||
        $last_name == undefined || $last_name == "" ||
        $enterprise == undefined || $enterprise <= 0 ||
        $job == undefined || $job == "") {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("Merci de renseigner tous les champs");
        }
        else {
            addNotificationError("Please fill in all fields");
        }
        return false;
    }
    const apiUrl = get(backend_url) + "v1/users/?id=" + $id;
    await authentication();
    let formData = new FormData();
    formData.append("id", $id.toString());
    formData.append("first_name", $first_name);
    formData.append("last_name", $last_name);
    formData.append("photo", $photo);
    formData.append("linkedin", $linkedin);
    formData.append("twitter", $twitter);
    formData.append("enterprise", $enterprise.toString());
    formData.append("job", $job);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: formData,
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationInfo("Profil modifié");
        }
        else {
            addNotificationInfo("Profile modified");
        }
        return "200";
    })
        .catch((error) => {
        if (error == "Error: 422") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Données saisies invalides");
            }
            else {
                addNotificationError("Invalid data entered");
            }
            return "422";
        }
        else {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Erreur");
            }
            else {
                addNotificationError("Error");
            }
            return "400";
        }
    });
}
/**
 * activate
 *
 * Validation du token pour autoriser la réinitialisation du mot de passe
 *
 * @param $id
 * @param $token
 * @returns
 */
export async function activate($id, $token) {
    const apiUrl = get(backend_url) + "v1/users/activate/";
    await authentication();
    const data = {
        id: $id,
        token: $token,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        return true;
    })
        .catch((error) => {
        return false;
    });
}
/**
 * resetPassword
 *
 * Génération d'un nouveau token côté backend et envoi du mail de réinitialisation
 *
 * @param $email
 * @returns
 */
export async function resetPassword($email) {
    if ($email == undefined || $email == "") {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("Email vide");
        }
        else {
            addNotificationError("Empty email");
        }
        return "";
    }
    const apiUrl = get(backend_url) + "v1/users/resetpassword/";
    await authentication();
    const data = {
        email: $email,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'PUT',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationInfo("Un email de réinit a été envoyé à votre adresse");
        }
        else {
            addNotificationInfo("A reset email has been sent to your address");
        }
        return "200";
    })
        .catch((error) => {
        if (error == "Error: 404") {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Email inconnu");
            }
            else {
                addNotificationError("Unknown email");
            }
            return "404";
        }
        else {
            if (get(storeLanguage) == get(lang_fr)) {
                addNotificationError("Erreur de réinitialisation");
            }
            else {
                addNotificationError("Reset error");
            }
            return "400";
        }
    });
}
/**
 * majPassword
 *
 * @param email
 * @param newPassword
 * @param token
 * @returns
 */
export async function majPassword(email, newPassword, token) {
    const apiUrl = get(backend_url) + "v1/users/modiflostpassword/";
    await authentication();
    const data = {
        email: email,
        new_password: newPassword,
        token: token,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'PUT',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationInfo("Mot de passe modifié, merci de vous connecter");
        }
        else {
            addNotificationInfo("Password changed, please login");
        }
        return true;
    })
        .catch((error) => {
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("Echec mise à jour");
        }
        else {
            addNotificationError("Update failed");
        }
        return false;
    });
}
/**
 * getUser
 * /users/id=? - GET
 */
export async function getUser(id) {
    const apiUrl = get(backend_url) + "v1/users/?id=" + id;
    ;
    await authentication();
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(access_token));
    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeUserLogin.set(data);
        storeIsLogin.set(true);
        return true;
    })
        .catch((error) => {
        storeUserLogin.set(storeUserEmpty);
        storeIsLogin.set(false);
        if (get(storeLanguage) == get(lang_fr)) {
            addNotificationError("Utilisateur inconnu ou informations de connection incorrectes");
        }
        else {
            addNotificationError("Unknown user or incorrect login information");
        }
        return false;
    });
}
/**
 * initError
 * @param errorStatus
 * @returns
 */
function initError(errorStatus) {
    let returnValue = "";
    if (errorStatus == "Error: 400") {
        returnValue = "Missing parameters";
    }
    else if (errorStatus == "Error: 401") {
        returnValue = "Unauthorized";
    }
    else if (errorStatus == "Error: 404") {
        returnValue = "Not found";
    }
    else if (errorStatus == "Error: 422") {
        returnValue = "Unprocessable entity";
    }
    else {
        returnValue = "Error";
    }
    return returnValue;
}
